import {defineNativeIdPathQueryString} from '@packages/systems/core/utils/NativeIdUtils';

/**
 * Allows to get native node using native id path inside the Canvas App only
 */
export const getNativeNodeByNativeIdPath = (
  nativeIdPath: string[]
): HTMLElement | null => {
  const doc = document;

  if (nativeIdPath.length === 0) {
    return doc.documentElement;
  }

  const queryString = defineNativeIdPathQueryString(nativeIdPath);

  return doc.querySelector(queryString) || null;
};
